// «Selfies activos» (announce-complete: subida cerrada y búsqueda por selfie abierta). El
// nombre es histórico: antes era «Publicar en la app»; «Publicar evento» es ahora
// isPublicGalleryOn. Presence of the stored publication date is authoritative, including
// historical formats. Empty values and DynamoDB's legacy NULL sentinel do not record it.
export function isEventPublished(event) {
    const completedDate = typeof event?.completedDate === 'string' ? event.completedDate.trim() : '';
    return completedDate !== '' && completedDate !== 'NULL';
}

// «Publicar evento»: galería pública visible y evento en el listado de la app, independiente
// de activar los selfies. El backend lo devuelve como estado efectivo (`publicGalleryActive`);
// un backend sin backfill no lo manda como interruptor propio y entonces se deriva de la
// activación de selfies, que era lo que entonces abría la galería. Ese fallback queda muerto
// cuando el backfill del índice de publicados haya corrido en los tres entornos.
export function isPublicGalleryOn(event) {
    if (typeof event?.publicGalleryActive === 'boolean') return event.publicGalleryActive;
    return isEventPublished(event);
}

// El listado de eventos de la app oculta los de un dueño sin saldo (totalBalance − usedBalance
// ≤ 0). La web ya deriva ese mismo `balance` de GET /user (redux/actions/users.js), así que
// se mira aquí sin tocar el contrato. Sin dato (GET /user aún no ha llegado) no se avisa.
export function hasNoBalance(user) {
    const raw = user?.balance;
    if (raw === undefined || raw === null || raw === '') return false;
    const balance = Number(raw);
    return Number.isFinite(balance) && balance <= 0;
}

// Avisos que siguen a «Publicar evento» (desde la pestaña o desde la cabecera): nunca bloquean,
// salen como toast de aviso. Devuelve claves i18n, en el orden en que se muestran.
export function publishEventWarnings({ result, active, publicPhotoCount }) {
    const warnings = [];
    if (result?.publicPosterWarning) warnings.push('publicGallery.posterWarning');
    if (active && publicPhotoCount === 0) warnings.push('publicGallery.emptyWarning');
    return warnings;
}
